import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: '12px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    overflow: 'hidden',
  },
  header: {
    padding: theme.spacing(2, 3),
    fontSize: '1.2rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  content: {
    padding: theme.spacing(3),
    color: theme.palette.text.secondary,
    fontSize: '0.95rem',
    lineHeight: 1.6,
  },
  actions: {
    padding: theme.spacing(2, 3),
    display: 'flex',
    gap: theme.spacing(1.5),
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.type === 'dark'
      ? theme.palette.backGroundItem.cardInterno
      : theme.palette.background.default,
    margin: 0,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      alignItems: 'stretch',
      '& > button': {
        width: '100%',
        margin: '0 !important',
      },
    },
  },
}))

export default useStyles
